const DataVisualizationIcon = ({
    size = 24,
    color = '#D9D9D9',
    strokeColor = 'color',
    secondaryStroke = '#235613',
}) => (
    <svg width={size} height={size} viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="3" width="18" height="17" rx="1" fill={color} stroke={strokeColor} strokeWidth="2" />
        <path d="M8 17V10" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" />
        <path d="M12 17V12" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" />
        <path d="M16 17V9" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" />
        <path d="M4 17V14" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" />
        <path d="M3.19702 9.65723L7.04333 6.46256" stroke="#235613" strokeWidth="0.8" strokeLinecap="round" />
        <path d="M7.11572 6.39999L11.2819 9.16455" stroke="#235613" strokeWidth="0.8" strokeLinecap="round" />
        <path d="M15.9529 4.91199L11.4762 9.27335" stroke="#235613" strokeWidth="0.8" strokeLinecap="round" />
        <path d="M7 1V4" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" />
        <path d="M13 1V4" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" />
    </svg>
);

export default DataVisualizationIcon;
